import { isValid, toDate } from 'date-fns';

export const useDateTimeFormatter = () => {
  function format(value: string | Date, options?: Intl.DateTimeFormatOptions) {
    const date = toDate(value);

    if (!isValid(date)) {
      return '';
    }

    return new Intl.DateTimeFormat(
      navigator.language,
      options || { dateStyle: 'medium', timeZone: 'UTC' },
    ).format(date);
  }

  return { format };
};
